import { useSelector } from 'react-redux'
import {
  selectError,
  selectFirstRender,
  selectIsFilterCollapsed,
  selectItemsList,
  selectLoading,
  selectNeedApply,
  selectQueryParams,
  selectTotalPages,
} from '../../store/moderation-page-items/selectors'
import { InitialModerationStateType } from '../../store/moderation-page-items/contracts'
import { selectIsModerator, selectModerationState } from '../../store/moderation-page-items/selectors'

type UseModerationPageType = InitialModerationStateType

export const useModerationPage = (): UseModerationPageType => {
  /*Is moderator variable*/
  const isModerator = useSelector(selectIsModerator)

  /*Items List*/
  const itemsList = useSelector(selectItemsList)

  /*Loading state*/
  const loading = useSelector(selectLoading)

  /*Query Params*/
  const query = useSelector(selectQueryParams)

  /*Total Pages*/
  const totalPages = useSelector(selectTotalPages)

  /*Item State*/
  const moderationState = useSelector(selectModerationState)

  /*Need Apply*/
  const needApply = useSelector(selectNeedApply)

  /*First Render Status*/
  const firstRender = useSelector(selectFirstRender)

  /*Filter collapsed status*/
  const isFilterCollapsed = useSelector(selectIsFilterCollapsed)

  /*Error*/
  const error = useSelector(selectError)

  return {
    isModerator,
    itemsList,
    loading,
    query,
    totalPages,
    moderationState,
    needApply,
    firstRender,
    isFilterCollapsed,
    error,
  }
}
